const fixedNav = document.querySelector('.fixedNav');
const navLinks = document.querySelectorAll('.fixedNavLink');
const fixedNavTrigger = document.querySelector('.fixedNavTrigger');

if (navLinks) {

	navLinks.forEach( (item) => {
		item.addEventListener('click', () => {
			let section = item.dataset.section;
			let targetedSection = document.getElementById(section);

			navLinks.forEach( (item) => {
				item.classList.remove('is-active')
			})

			item.classList.add('is-active');

			targetedSection.scrollIntoView({
				behavior: "smooth",
				block: "start",
				inline: "nearest"
			});
		});
	})
}

if (fixedNavTrigger) {

	fixedNavTrigger.addEventListener('click', () => {
		if (fixedNavTrigger.classList.contains('is-active')) {
			fixedNavTrigger.classList.remove('is-active');
			fixedNav.classList.remove('is-active');
			fixedNavTrigger.innerHTML = 'Open';
		} else {
			fixedNavTrigger.classList.add('is-active');
			fixedNav.classList.add('is-active');
			fixedNavTrigger.innerHTML = 'Close';
		}
	})
}
